import { seededRandom } from './seededRandom';

/**
 * Shuffles an array using a seeded random number generator.
 *
 * @template T - The type of elements in the array.
 * @param {T[]} array - The array to shuffle.
 * @param {number} seed - The seed for the random number generator.
 * @returns {T[]} - The shuffled array.
 */
export const shuffleWithSeed = <T>(array: T[], seed: number): T[] => {
  const rng = seededRandom(seed);
  return [...array].sort(() => rng() - 0.5);
};
